import { Container } from '@/components/Container';
import { AppLink } from '@/components/AppLink';
import { PORTAL_URL, SHOW_EVENTS } from '@/config';
import { logo } from '@/data/images';
import { SITE } from '@/data/site';

const COLUMNS = [
  {
    label: 'About',
    links: [
      ['About ITES', '/about'],
      ['Aims & objectives', '/about'],
      ['Managing Committee', '/about'],
      ['Events', '/events'],
    ],
  },
  {
    label: 'Students',
    links: [
      ['Courses & syllabi', '/courses'],
      ['Examinations', '/examinations'],
      ['Notice board', '/notices'],
      ["Student's E-Journal", '/e-journal'],
    ],
  },
  {
    label: 'Institutes',
    links: [
      ['Affiliation & overseas', '/affiliation'],
      ['Affiliated institutes', '/centres'],
      ['Exam centres', '/centres/practical'],
      ['Portal login', PORTAL_URL],
    ],
  },
] as const;

export function Footer() {
  return (
    <footer className="bg-navy-900 text-on-dark">
      <Container className="pt-14 pb-7">
        <div className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,190px),1fr))] gap-x-10 gap-y-9">
          <div className="min-w-0">
            <div className="flex items-center gap-3.5">
              {/* The disc clips the logo so only the round emblem at the left of the lockup shows. */}
              <div className="flex size-14 flex-none items-center overflow-hidden rounded-full bg-white pl-[3px]">
                <img src={logo.src} alt="" width={logo.width} height={logo.height} className="block h-[50px] w-auto max-w-none" />
              </div>
              <p className="m-0 font-serif text-[1.125rem] leading-[1.25] font-semibold text-white">{SITE.name}</p>
            </div>
            <p className="mt-4 text-[0.9375rem] leading-[1.6]">Promoting technical and vocational education since 1941.</p>
          </div>

          {COLUMNS.map((col) => (
            <nav key={col.label} aria-label={col.label} className="flex flex-col gap-2.5 text-[0.9375rem] max-sm:gap-0">
              <p className="m-0 mb-1 font-mono text-[0.75rem] tracking-[0.08em] text-sky-300 uppercase">{col.label}</p>
              {col.links.filter(([, href]) => SHOW_EVENTS || href !== '/events').map(([label, href]) => (
                <AppLink key={label} href={href} className="tap text-white no-underline">
                  {label}
                </AppLink>
              ))}
            </nav>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap justify-between gap-x-6 gap-y-2.5 border-t border-rule-dark pt-5 text-[0.875rem]">
          <span>© 2026 {SITE.name}</span>
          <div className="flex flex-wrap gap-5">
            <AppLink href="/contact" className="tap text-on-dark underline">Contact</AppLink>
          </div>
        </div>
      </Container>
    </footer>
  );
}
